<template>
  <div>
    <el-card>
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>
            <span>{{ formData.visitDate }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{ formData.scmName }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="table-text" v-html="formData.visitTitle"></span>
          </h6>
          <div>
            <span class="table-text">No：{{ formData.visitNo }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="table-text"
              >Create：{{ formData.createByName }} at
              {{ formData.createTime }}</span
            >
          </div>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-main role="button" style="color: #606266">
            <i
              v-if="isShowMainPanel"
              class="fa fa-chevron-down"
              title="收起"
            ></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>
      <b-collapse v-model="isShowMainPanel" id="collapse-main">
        <div class="mt-3">
          <span style="color: #007bff" class="table-text">{{
            formData.visitPerson
          }}</span>
          <el-divider direction="vertical"></el-divider>
          <span style="color: #444444" class="table-text mr-1"
            >{{ $l('visit_label_scmPerson') || '厂方人员：' }}：</span
          ><span style="color: #444444" class="table-text">{{
            formData.scmPerson
          }}</span>
          <div class="mt-2" v-if="formData.visitDescription">
            <p
              style="
                        font-size: 14px;
                        color: #606266;
                        white-space: pre-line;
                      "
              v-html="formData.visitDescription"
            ></p>
          </div>
        </div>
        <!-- <b-row class="mt-4 mb-1">
                  <b-col>
                    <b-button
                      class="mr-2"
                      size="sm"
                      @click="goBack"
                      variant="outline-secondary"
                      >{{ $l('btn_go_back') || '返回' }}</b-button
                    >
                    <b-button
                      class="mr-2"
                      size="sm"
                      variant="outline-secondary"
                      >{{ $l('btn_refresh') || '刷新数据' }}</b-button
                    >
                    <b-button class="mr-2" size="sm" variant="outline-dark">{{
                      $l('btn_edit') || '编辑拜访记录'
                    }}</b-button>
                  </b-col>
                </b-row> -->
      </b-collapse>
    </el-card>
    <el-card class="mt-2">
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>{{ $l('tips_title_visit_score') || '拜访评分记录' }}</h6>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-rating role="button" style="color: #606266">
            <i
              v-if="isShowRatingPanel"
              class="fa fa-chevron-down"
              title="收起"
            ></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>
      <b-collapse v-model="isShowRatingPanel" id="collapse-rating">
        <visit-score-list
          v-if="queryParams.visitCode"
          class="mt-3"
          :autoLoad="true"
          :visitCode="queryParams.visitCode"
        ></visit-score-list>
      </b-collapse>
    </el-card>
    <el-card class="mt-2">
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>{{ $l('tips_title_visit_file') || '拜访文件信息' }}</h6>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-images role="button" style="color: #606266">
            <i
              v-if="isShowImagePanel"
              class="fa fa-chevron-down"
              title="收起"
            ></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>
      <b-collapse v-model="isShowImagePanel" id="collapse-images">
        <visit-image-list
          v-if="queryParams.visitCode"
          class="mt-3"
          :autoLoad="true"
          :visitCode="queryParams.visitCode"
          :scmCode="queryParams.scmCode"
        ></visit-image-list>
      </b-collapse>
    </el-card>
  </div>
</template>
<script>
export default {
  components: {
    VisitScoreList: () => import('./components/visitScoreList.vue'),
    VisitImageList: () => import('./components/visitImageList.vue')
  },
  data() {
    return {
      isShowMainPanel: true,
      isShowRatingPanel: true,
      isShowImagePanel: true,
      pageHeader: '',
      params: {
        type: '',
        visitCode: ''
      },
      formData: {
        visitCode: '',
        visitNo: '',
        scmCode: '',
        visitDate: '',
        visitOwnerCode: '',
        scmPerson: '',
        visitPerson: '',
        visitTitle: '',
        visitDescription: '',
        scmVisitStatus: '',
        scmVisitStatusName: '',
        createTime: '',
        createByName: '',
        modifyTime: '',
        modifyByName: '',
        visitScore: '',
        visitOwnerUrl: ''
      },
      queryParams: {
        scmCode: '',
        visitCode: ''
      }
    }
  },
  mounted() {
    if (this.$route.params.visitCode) {
      let type = this.$route.params.pageType
      let visitCode = this.$route.params.visitCode
      this.init(type, visitCode)
    }
  },
  activated() {
    if (this.$route.params.visitCode) {
      let type = this.$route.params.pageType
      let visitCode = this.$route.params.visitCode
      this.init(type, visitCode)
    }
  },
  methods: {
    init(type, visitCode) {
      this.queryParams = {}
      this.detailLoad(visitCode)
    },
    detailLoad(val) {
      let param = { visitCode: val }
      this.$api.scmInfoVisitDetailApi(param).then((res) => {
        this.formData = res.body
        this.queryParams.scmCode = this.formData.scmCode
        this.queryParams.visitCode = this.formData.visitCode
      })
    },
    goBack() {
      this.back()
    },
    back() {
      history.back()
    }
  }
}
</script>
<style lang="scss" scoped>
.table-text {
  color: #606266;
  font-size: 14px;
}
.label-title {
  color: #606266;
  font-size: 14.4px;
  font-weight: 500;
}
</style>
